<app-kontable
  id="dt_division"
  [source]="srvDivision.divisions"
  [title]="'divisionList.sectionTitle' | translate"
  [columns]="['id', 'code', 'name', 'description', 'logo_name', 'logo']"
  [titles]="['common.id', 'common.code', 'common.name', 'common.description', 'common.logo_name', 'common.logo']"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [(fireNewDataAvailable)]="newDataAvailable"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
  *ngIf="srvDivision.divisionEditing"
  [visible]="srvDivision.divisionEditing"
  [modal]="true"
  header="{{modalTitle}}"
  [resizable]="false"
  [draggable]="false"
  [width]="500"
  (visibleChange)="closeAddDialog()">
  <app-division-form
    (divisionAdded)="divisionAdded($event)"
    (divisionUpdated)="divisionUpdated($event)"
    [dialogBoxDivision]="srvDivision.divisionEditing"
  ></app-division-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/division/division.component.html